<form [formGroup]="genAIFeatureSettingsForm" (ngSubmit)="onSubmitGenAIFeatureSettings()">
  <div class="form-group">
    <label class="form-label">
      {{ 'Settings::License.Limit' | abpLocalization }}{{ ': ' }}
      @if (!licenseInfo?.isInfinite) {
        <span class="bold">
          {{ licenseInfo?.remainingLicenseCount + licenseInfo?.activeLicenseCount }}
        </span>
      }
    </label>
    @if (licenseInfo?.isInfinite) {
      <i class="ms-1 far fa-infinity"></i>
    }
  </div>

  <div class="form-group pt-2">
    <label for="aiInsightsDailyLimit">
      {{ 'Settings::DisplayName:GenerativeAI.AIInsightsDailyLimit' | abpLocalization }}
    </label>
    <input
      id="aiInsightsDailyLimit"
      type="number"
      class="form-control"
      formControlName="aiInsightsDailyLimit"
      [min]="0"
      step="any" />
    <small class="form-text text-muted">
      {{ 'Settings::Description:GenerativeAI.AIInsightsDailyLimit' | abpLocalization }}
    </small>
  </div>

  <div class="form-group pt-2">
    <label for="askGenAIMonthlyLimit">
      {{ 'Settings::DisplayName:GenerativeAI.AskGenAIMonthlyLimit' | abpLocalization }}
    </label>
    <input
      id="askGenAIMonthlyLimit"
      type="number"
      class="form-control"
      formControlName="askGenAIMonthlyLimit"
      [min]="0"
      step="any" />
    <small class="form-text text-muted">
      {{ 'Settings::Description:GenerativeAI.AskGenAIMonthlyLimit' | abpLocalization }}
    </small>
  </div>

  <div class="form-group pt-2">
    <label for="aiCoachingMonthlyAgentLimit">
      {{ 'Settings::DisplayName:GenerativeAI.AICoachingMonthlyAgentLimit' | abpLocalization }}
    </label>
    <input
      id="aiCoachingMonthlyAgentLimit"
      type="number"
      class="form-control"
      formControlName="aiCoachingMonthlyAgentLimit"
      decimalMarker=","
      [min]="0"
      step="any" />
    <small class="form-text text-muted">
      {{ 'Settings::Description:GenerativeAI.AICoachingMonthlyAgentLimit' | abpLocalization }}
    </small>
  </div>

  <div class="pt-2">
    <div class="setting-section-container shadow-sm">
      <label>
        {{ 'Settings::DisplayName:GenerativeAI.QueryWithGenAIMonthlyLimit' | abpLocalization }}
      </label>
      <div class="form-group pt-2">
        <input
          id="queryWithGenAIMonthlyLimit"
          type="number"
          class="form-control"
          formControlName="queryWithGenAIMonthlyLimit"
          [min]="0"
          step="any" />
        <small class="form-text text-muted">
          {{ 'Settings::Description:GenerativeAI.QueryWithGenAIMonthlyLimit' | abpLocalization }}
        </small>
      </div>
      <div class="form-group pt-2">
        <ca-select
          id="queryWithGenAILookbackPeriod"
          formControlName="queryWithGenAILookbackPeriod"
          [bringToFront]="true">
          <ca-option
            *ngFor="let option of lookbackPeriodOptions; trackBy: trackByCode"
            [value]="option.code">
            {{ 'GenericLookup::' + option.code | abpLocalization }}
          </ca-option>
          <ca-option [value]="'all'">
            {{ 'Category::AllConversations' | abpLocalization }}
          </ca-option>
        </ca-select>
        <small class="form-text text-muted">
          {{ 'Settings::Description:GenerativeAI.QueryWithGenAILookbackPeriod' | abpLocalization }}
        </small>
      </div>
    </div>
  </div>

  <div class="form-group pt-2">
    <label for="autoTagLimit">
      {{ 'Settings::DisplayName:GenerativeAI.AutoTagLimit' | abpLocalization }}
    </label>
    <input
      id="autoTagLimit"
      type="number"
      class="form-control"
      formControlName="autoTagLimit"
      [min]="0"
      step="any" />
    <small class="form-text text-muted">
      {{ 'Settings::Description:GenerativeAI.AutoTagLimit' | abpLocalization }}
    </small>
  </div>

  <div class="pt-2">
    <small class="form-text text-muted">
      0 = {{ 'Conversation::AutomaticSummarization:Unlimited' | abpLocalization }}
    </small>
  </div>

  <div>
    <button type="submit" class="btn btn-primary mt-3" [disabled]="isSaving">
      <i class="me-1 fas fa-save"></i>
      {{ 'AbpUi::Save' | abpLocalization }}
    </button>
  </div>
</form>
